import getCssRuleBySelector from './get-css-rule-by-selector';

const setRuleForSelector = (selector, stylesheet, property) => {
  const cssRule = getCssRuleBySelector(stylesheet, selector);

  if (cssRule) {
    cssRule.style.cssText += property;
  } else {
    stylesheet.insertRule(`${selector} {${property}}`, stylesheet.cssRules.length);
  }
};

export default setRuleForSelector;
